import { classNames } from 'libs/react';
import { React } from 'libs/react';
import { Button } from 'components/Button';
import { Icon } from 'components/Icon';
import { Fragment } from 'react';
import './FormIconCheckBox.scss';
/**
 * @component FormIconCheckBox
 * @since 1.0.0
 * @hidden
 */
export function FormIconCheckBox(props) {
    const { checked, checkedColor, checkedIcon, disabled, onChange, uncheckedIcon } = props;
    const className = classNames('form-icon-check', {
        'form-icon-check--is-checked': checked && !disabled,
        'form-icon-check--checked-color--primary': checkedColor == 'primary',
        'form-icon-check--checked-color--secondary': checkedColor == 'secondary'
    }, props.className);
    return (React.createElement("div", { className: className },
        React.createElement("div", { className: "form-icon-check-field" },
            React.createElement("div", { className: "form-icon-check-field-body" }, disabled ? (React.createElement(Icon, { value: "hexagon-check", className: className })) : (React.createElement(Fragment, null,
                React.createElement(Button, { style: "picto", size: "small", picto: checked ? checkedIcon : uncheckedIcon, disabled: disabled, onPress: () => onChange(!checked), stopPropagation: true })))))));
}
